/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

import { useNavigationStore } from "@/stores/navigation.js";
import alfrescoNodeService from "@/services/AlfrescoNodeService.js";
import workspaceService from "@/services/WorkspaceService.js";
const SPLITTER = "|";

/**
 * Service class providing functionality to handle actions related to tree structures and navigation paths.
 */
class LibVueActionService {
  async getInitialTree() {
    try {
      const workspaces = await workspaceService.searchAllWorkspaces(
        "AND NOT pm:typeEspace:'actes'",
      );

      const promises = workspaces.map(async (workspace) => {
        const documentLibrary = await alfrescoNodeService.getDocumentLibrary(
          workspace.id,
        );
        return {
          key: workspace.id,
          label: workspace.title,
          icon: "ri-inbox-line",
          data: documentLibrary,
          children: [],
          leaf: false,
        };
      });

      const nodes = await Promise.all(promises);

      return nodes
        .filter((workspace) => workspace.data !== undefined)
        .sort((a, b) => a.label.localeCompare(b.label));
    } catch (error) {
      console.error("Error initializing tree:", error);
      return [];
    }
  }
  buildPathKeys(currentNode) {
    if (!useNavigationStore().isInUserHome) {
      const pathElements = currentNode.path.elements;
      let parentKey = "";
      const keys = [];

      for (const node of pathElements) {
        let key = null;
        if (node?.nodeType === "st:site") {
          key = node.id;
        } else if (node?.isFolder && node.name !== "documentLibrary") {
          key = parentKey ? parentKey + SPLITTER + node.id : node.id;
        }
        if (key && key.charAt(0) === "|") {
          key = key.slice(1);
        }
        if (key) {
          keys.push({ key, node });
          parentKey = key;
        }
      }

      return keys;
    } else {
      return this.buildPathKeysInUserHome(currentNode);
    }
  }
  buildPathKeysInUserHome(currentNode) {
    const pathElements = currentNode.path.elements.slice(2);
    let parentKey = "";
    let keys = [];
    for (const node of pathElements) {
      let key = null;
      key = node.id;
      if (node?.isFolder && node.name !== "documentLibrary") {
        key = parentKey ? parentKey + SPLITTER + node.id : node.id;
      }
      if (key && key.charAt(0) === "|") {
        key = key.slice(1);
      }
      if (key) {
        keys.push({ key, node });
        parentKey = key;
      }
    }
    return keys;
  }

  async expandPathKeys({
    keys,
    nodes,
    expandedKeys,
    onNodeExpand,
    currentNode,
  }) {
    let parentKey = "";

    for (const { key, node } of keys) {
      await onNodeExpand({ key: key, data: node }, nodes);
      expandedKeys[key] = true;
      parentKey = key;
    }

    const finalKey = parentKey + SPLITTER + currentNode.id;
    await onNodeExpand({ key: finalKey, data: currentNode }, nodes);
    expandedKeys[finalKey] = true;
  }
}
export default new LibVueActionService();
